<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<div class="profile">
	<div class="info">
		<img
			[src]="profilePicUrl"
			class="avatar"
			alt=""
		/>

		<div class="username-role">
			<span class="username">{{ username }}</span>

			<span class="role">{{ role }}</span>
		</div>
	</div>

	<span class="icon-chevron-down"></span>
</div>
